import store from "@/store/";

export default async ({ from, to, next }) => {
  if(to.query.newSession !== undefined) {
    console.log('middleware - newSession');
    await store.commit('common/reset', {}, {root: true});
    await store.commit('subscription/reset', {}, {root: true});
    await store.commit('contract/reset', {}, {root: true});
    await store.commit('consumption/reset', {}, {root: true});


    // Remove other contracts
    let allowedModules = ['common', 'subscription', 'contract', 'consumption', 'offer', 'comeback'];
    let otherModules = Object.keys(store.state).filter(module => allowedModules.indexOf(module) < 0);

    otherModules.forEach(module => {
      store.unregisterModule(module)
    });

    delete to.query.newSession;
    return next({ path: to.path, query: to.query });
  }

  return next();
}


// WEBPACK FOOTER //
// ./src/router/middleware/newSession.js